export const state = () => ({
  version: process.env.version,
})

export default {
  state,
}
